import type { IIssueInfo } from '@pressreader/content-types';
import { IPopupResult, IPopupSagas } from '@pressreader/popups-core';
import { IDialogPopup } from '@pressreader/popups-types';
import type { PopupDynamicSizeMode } from '@pressreader/ui-popups';

export interface CommentsDialogPopup extends IDialogPopup {
    articleId: string;
    issueCidDateKey?: IIssueInfo['issueCidDateKey'];
    heightCalcMode?: PopupDynamicSizeMode;
}

export type CommentsDialogOptions = Omit<CommentsDialogPopup, keyof IDialogPopup>;

export interface CommentsDialogResultCommentsMetadata {
    articleId: string;
    totalCommentsCount: number;
}

export type CommentsDialogOpenParameters = IPopupSagas<CommentsDialogResultCommentsMetadata>;

export type CommentsDialogResult = IPopupResult<CommentsDialogResultCommentsMetadata | undefined>;

export enum CommentsDialogStatus {
    OPENING = 'opening',
    OPEN = 'open',
    CLOSING = 'closing',
    CLOSED = 'closed',
}
